import { makeAutoObservable } from 'mobx';
import ErrorUtil from '../error/ErrorUtil';
import API, { CommonAPI } from '../util/ApiUtil';
import { FetchStatus } from '../util/FetchStatus';

export interface DataHolder {
  status: FetchStatus;
  hasCampaign: boolean;
}

export interface ScaOfferProps {
  scaOfferCode?: string;
  buildingId?: number;
  addressId?: number;
}

export interface CampaignParams {
  recApiOfferCodes?: string | string[];
  segmentOfferCode?: string;
  scaOffer?: ScaOfferProps;
  buildingId?: number;
}

export const getCampaignKey = (params: CampaignParams): string => {
  return `${params.recApiOfferCodes}_${params.segmentOfferCode}_${params.scaOffer?.scaOfferCode}_${params.scaOffer?.addressId}_${params.scaOffer?.buildingId}`;
};

class CampaignStore {
  public campaignMap = new Map<string | string[], DataHolder>();
  public customerId: number;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public loadCampaign = async (campaignParams: CampaignParams, customerId: number): Promise<void> => {
    this.resetStateIfNecessary(customerId);
    const key = getCampaignKey(campaignParams);
    if (!customerId || [FetchStatus.FETCHED, FetchStatus.FETCHING].includes(this.campaignMap.get(key)?.status)) {
      return Promise.resolve();
    }
    this.setState(key, false, FetchStatus.FETCHING);
    const { segmentOfferCode, recApiOfferCodes, scaOffer } = campaignParams;

    try {
      const response = campaignParams.segmentOfferCode
        ? await API.get('/campaign/hasCampaign', {
            params: { campaignName: segmentOfferCode },
          })
        : await CommonAPI.get('/offers/hasOffers', {
            params: {
              offerNames: [recApiOfferCodes],
              scaOfferCode: scaOffer?.scaOfferCode,
              addressId: scaOffer?.addressId,
              buildingId: scaOffer?.buildingId,
            },
          });
      this.setState(key, response.data.hasCampaign, FetchStatus.FETCHED);
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
      this.setState(key, false, FetchStatus.ERROR);
    }
  };

  private setState(key: string, hasCampaign: boolean, status: FetchStatus) {
    this.campaignMap.set(key, { hasCampaign, status });
  }

  private resetStateIfNecessary(customerId: number) {
    if (this.customerId !== customerId) {
      this.campaignMap = new Map<string, DataHolder>();
      this.customerId = customerId;
    }
  }
}

export default CampaignStore;
